import { STATES } from "@/constants/states";

import { RELATIONSHIP_TO_INSURED_OPTIONS } from "../../Providers/schema/newPatientFormSchema";

const BASIC_INITIAL_VALUES = {
  "address.city": "",
  "address.state": "",
  "address.street": "",
  "address.zip_code": "",
  dob: "",
  email: "",
  first_name: "",
  gender: "",
  last_name: "",
  mobile: "",
};

export const PREFERRED_NAME_SCHEMA_NON_PATIENT = Object.freeze({
  elementConfig: {
    label: "Nickname/Preferred First Name",
    optional: true,
    placeholder: "Nickname",
    type: "text",
  },
  elementType: "input",
  name: "preferred_name",
});

export const PREFERRED_NAME_SCHEMA_PATIENT = Object.freeze({
  elementConfig: {
    label: "Nickname",
    optional: true,
    placeholder: "Nickname",
    subtext: "What you’d like your provider to call you",
    type: "text",
  },
  elementType: "input",
  name: "preferred_name",
});

export const PREFERRED_PRONOUNS_SCHEMA = Object.freeze({
  elementConfig: {
    label: "Preferred Pronouns",
    optional: true,
    options: [
      { display: "He / him", value: "He / him" },
      { display: "She / her", value: "She / her" },
      { display: "They / them", value: "They / them" },
    ],
    placeholder: "",
  },
  elementType: "select",
  name: "preferred_pronouns",
});

export const BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "Legal First Name",
      placeholder: "Legal First Name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Legal Last Name",
      placeholder: "Legal Last Name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  PREFERRED_NAME_SCHEMA_NON_PATIENT,
  PREFERRED_PRONOUNS_SCHEMA,
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
];

export const PATIENT_BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "Legal First Name",
      placeholder: "Legal First Name",
      type: "text",
    },
    elementType: "readOnly",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Legal Last Name",
      placeholder: "Legal Last Name",
      type: "text",
    },
    elementType: "readOnly",
    name: "last_name",
  },
  PREFERRED_NAME_SCHEMA_PATIENT,
  PREFERRED_PRONOUNS_SCHEMA,
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "readOnly",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
];

export const EMERGENCY_SCHEMA = [
  {
    elementConfig: {
      label: "Emergency Contact Person",
      placeholder: "Emergency Contact Person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_person",
  },
  {
    elementConfig: {
      label: "Emergency Contact Number",
      placeholder: "Emergency Contact Number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_number",
  },
];

export const PRI_INSURANCE_SCHEMA = [
  {
    elementConfig: {
      label: "State",
      options: [],
      placeholder: "Select State",
    },
    elementType: "select",
    name: "primary_insurance.state",
  },
  {
    elementConfig: {
      label: "Carrier",
      options: [],
      placeholder: "Select Carrier",
      sentenceCase: false,
    },
    elementType: "select",
    name: "primary_insurance.carrier",
  },
  {
    elementConfig: {
      label: "Member ID",
      placeholder: "Enter Member ID",
      type: "text",
    },
    elementType: "input",
    name: "primary_insurance.member_id",
  },
  {
    elementConfig: {
      label: "Group ID",
      placeholder: "Enter Group ID",
      type: "text",
    },
    elementType: "input",
    name: "primary_insurance.group_id",
  },
  {
    elementType: "InsuranceCard",
    name: "primary_insurance.card_front",
    type: "f",
  },
  {
    elementType: "InsuranceCard",
    name: "primary_insurance.card_back",
    type: "b",
  },
  {
    elementConfig: {
      label: "Policy Holder Name",
      placeholder: "Enter Policy Holder Name",
      type: "text",
    },
    elementType: "input",
    name: "primary_insurance.policy_holder_name",
  },
  {
    elementConfig: {
      label: "Relationship to Insured",
      options: RELATIONSHIP_TO_INSURED_OPTIONS,
      placeholder: "Select Relationship",
    },
    elementType: "select",
    name: "primary_insurance.policy_relationship",
  },
  {
    elementConfig: {
      label: "Policy Holder Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "primary_insurance.policy_dob",
  },
];

export const SEC_INSURANCE_SCHEMA = [
  {
    elementConfig: {
      label: "State",
      options: [],
      placeholder: "Select State",
    },
    elementType: "select",
    name: "secondary_insurance.state",
  },
  {
    elementConfig: {
      label: "Carrier",
      options: [],
      placeholder: "Select Carrier",
      sentenceCase: false,
    },
    elementType: "select",
    name: "secondary_insurance.carrier",
  },
  {
    elementConfig: {
      label: "Member Id",
      placeholder: "Enter Member Id",
      type: "text",
    },
    elementType: "input",
    name: "secondary_insurance.member_id",
  },
  {
    elementConfig: {
      label: "Group Id",
      placeholder: "Enter Group Id",
      type: "text",
    },
    elementType: "input",
    name: "secondary_insurance.group_id",
  },
  {
    elementType: "InsuranceCard",
    name: "secondary_insurance.card_front",
    type: "f",
  },
  {
    elementType: "InsuranceCard",
    name: "secondary_insurance.card_back",
    type: "b",
  },
  {
    elementConfig: {
      label: "Policy Holder Name",
      placeholder: "Enter Policy Holder Name",
      type: "text",
    },
    elementType: "input",
    name: "secondary_insurance.policy_holder_name",
  },
  {
    elementConfig: {
      label: "Relationship to Insured",
      options: RELATIONSHIP_TO_INSURED_OPTIONS,
      placeholder: "Select Relationship",
    },
    elementType: "select",
    name: "secondary_insurance.policy_relationship",
  },
  {
    elementConfig: {
      label: "Policy Holder Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "secondary_insurance.policy_dob",
  },
];
